export enum QuestionnaireAnswerType {
  STRING = 'string',
  BOOLEAN = 'boolean',
  DATE = 'date',
  DATE_TIME = 'dateTime',
  TIME = 'time',
  DECIMAL = 'decimal',
  INTEGER = 'integer',
  REFERENCE = 'reference',
  CODING = 'coding',
  GROUP = 'group',
  TEXT = 'text',
  CHOICE = 'choice'
}
